import { AppDispatch, RootState } from '../index';
import { FetchState } from '../fetchState';
import { baseSlice, BaseType, getItem } from '../baseHelper';
import { EntityState } from '@api/models/enums/EntityState';
import { ActivityDto } from '@api/models/activity/ActivityDto';
import { activityService } from '@api/services/services';

type State = BaseType<ActivityDto>;

const initialState: State = {
  state: FetchState.None,
  data: {
    id: '',
    name: '',
    nameEn: '',
    oneTimeEntry: false,
    riskRequired: true,
    riskPass: true,
    state: EntityState.Active,
    certificates: [],
    stateChangeEnabled: true,
  },
};

export const activitySlice = baseSlice({
  name: 'activity',
  initialState,
});

export const selectActivityState = (state: RootState) => state.activity.state;
export const selectActivity = (state: RootState) => state.activity.data;
export const activityActions = activitySlice.actions;

export const getActivity = (activityId: string) => (dispatch: AppDispatch) => {
  const handleGetData = () => {
    return activityService.getById(activityId);
  };

  getItem({
    dispatch,
    actions: activityActions,
    getData: handleGetData,
  });
};
